export default __webpack_public_path__ + "static/media/small.b6c60ed6.jpg";